<script lang="ts" setup>
import AppButton from '~/components/ui/buttons/AppButton.vue';
import useCatalogStore from '~/shared/store/modules/catalog';
import AppFilterCheckbox from '~/components/ui/form/formElements/AppFilterCheckbox.vue';
import {useMonitorSize} from "~/composables/monitor-size";
import type { ISetSelectedBrand, ISetSelectedFilter } from '~/shared/interfaces/catalog';
import type {IMonitorSize} from "~/shared/interfaces/composables";

const catalogStore = useCatalogStore();
let sizes: IMonitorSize | null = useMonitorSize()

function removeBrand({ category }: { category: ISetSelectedBrand }) {
  catalogStore.setBrandsSelectedStatus(category);
}

function removeFilter({ category }: { category: ISetSelectedFilter }) {
  catalogStore.setFiltersSelectedStatus(category);
}

function clearSelectedList() {
  catalogStore.clearSelectedFiltersList();
}

</script>

<template>
  <div class="selected-filters">
    <div class="selected-filters__wrapper">
      <div class="selected-filters__container">
        <AppFilterCheckbox
          class="selected-filters__brand"
          v-for="({ name, value }) in catalogStore.selectedFilters.brands"
          :id="value + '__selected-filter'"
          :name="sizes?.isMobile ? name : `Бренд: ${name}`"
          :is-selected="true"
          :has-close-btn="true"
          :category="{
            name,
            value,
            active: false,
          }"
          @select-value="removeBrand"
        />
        <template v-for="({ values, filterName, filterId }) in catalogStore.selectedFilters.filters">
          <AppFilterCheckbox
            v-for="({ name, value }) in values"
            :id="value + '__selected-filter'"
            :name="sizes?.isMobile ? name : `${filterName}: ${name}`"
            :is-selected="true"
            :has-close-btn="true"
            :category="{
              filterId,
              filterName,
              value,
              name,
              active: false,
            }"
            @select-value="removeFilter"
          />
        </template>
        <AppButton
          v-if="catalogStore.selectedFilters.filters.length || catalogStore.selectedFilters.brands.length"
          @click="clearSelectedList"
          text="Сбросить всё"
          size="xs"
          :font-weight="400"
          type="neutral"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.selected-filters {
  @include md-breakpoint {
    height: 36px;
    position: relative;
    margin: 4px 0 24px;
  }

  .selected-filters__wrapper {
    @include md-breakpoint {
      flex-wrap: nowrap;
      overflow: auto;
      max-width: calc(100% + 40px);
      position: absolute;
      left: -20px;
      top: 0;

      &::-webkit-scrollbar {
        display: none;
      }
    }
  }

  &__container {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    @include md-breakpoint {
      flex-wrap: nowrap;
      padding: 0 20px;
      width: max-content;
    }
  }

  &__brand {
    text-transform: uppercase;
  }
}

</style>
